import React, { useState } from 'react';
import IdleTimer from 'react-idle-timer';
import { useDispatch, useSelector } from 'react-redux';
import ResponsiveModal from 'react-responsive-modal';

import { Headline, P } from '../../components/Typography';
import { logoutSession } from '../../redux/session/actions';
import { getUserInfo } from '../../redux/session/selectors';
import { UserInfo } from '../../services/auth';
import styled from '../../styles';

const modalStyles = {
  modal: {
    borderRadius: 4,
  },
};

const ModalContent = styled.div({
  maxWidth: '360px',
  padding: '40px',
  textAlign: 'center',
});

const SessionTimeout = ({ children }: SessionTimeoutProps) => {
  const maxIdleTime = parseInt(
    process.env.REACT_APP_MAX_IDLE_TIMEOUT || '30',
    10
  );
  const gracePeriod = parseInt(
    process.env.REACT_APP_IDLE_GRACE_PERIOD || '2',
    10
  );
  const idleTimeout = 1000 * 60 * (maxIdleTime - gracePeriod);
  const [isOpen, setOpen] = useState(false);
  const [logoutTimer, setLogoutTimer] = useState();
  const user = useSelector(getUserInfo) as UserInfo;
  const dispatch = useDispatch();
  const onIdleHandler = () => {
    if (user.id) {
      setOpen(true);
      setLogoutTimer(
        setTimeout(() => {
          setOpen(false);
          dispatch(
            logoutSession({
              expired: true,
            })
          );
        }, 1000 * 60 * gracePeriod)
      );
    }
  };
  const onActiveHandler = () => {
    setOpen(false);
    clearTimeout(logoutTimer);
    setLogoutTimer(undefined);
  };
  const onCloseHandler = () => {
    setOpen(false);
  };
  return (
    <IdleTimer
      timeout={idleTimeout}
      onIdle={onIdleHandler}
      onActive={onActiveHandler}
    >
      {children}
      <ResponsiveModal
        onClose={onCloseHandler}
        open={isOpen}
        styles={modalStyles}
        center
      >
        <ModalContent>
          <Headline isBlock>Uh oh!</Headline>
          <P>
            {`You will be logged out due to inactivity in ${gracePeriod} minutes.`}
          </P>
        </ModalContent>
      </ResponsiveModal>
    </IdleTimer>
  );
};

interface SessionTimeoutProps {
  children: any;
}

export default SessionTimeout;
